module.exports = __webpack_public_path__ + "static/media/twitter.1092570c039452d90551d328e0652bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter.png
// module id = 2501
// module chunks = 1